// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"S9-z"};